const MUTATION_TYPE = {
    SET_CATEGORY_GROUPS: 'SET_CATEGORY_GROUPS',
};

const state = {
    entities: {},
    entityIds: [],
};

const actions = {
    getCategoryGroups({ commit }) {
        axios.get(laroute.route('api.category-groups.index'))
            .then((response) => {
                commit(MUTATION_TYPE.SET_CATEGORY_GROUPS, {
                    categoryGroups: response.data.data
                });
            })
    },
};

const mutations = {
    [MUTATION_TYPE.SET_CATEGORY_GROUPS](state, { categoryGroups }) {
        const entityMap = categoryGroups.reduce((acc, item) => {
            acc.ids.push(item.id);
            acc.entities[item.id] = item;
            return acc;
        }, { ids: [], entities: {} });

        state.entities = entityMap.entities;
        state.entityIds = entityMap.ids;
    }
};

const getters = {
    categoryGroups: state => state.entityIds.map(id => state.entities[id]),
    categoryGroupsById: state => state.entities,
};

export default {
    // namespaced: true,
    getters,
    state,
    mutations,
    actions,
}
